// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/settings/intake/${file}.vue`
  );

export default [
  // intake-variety
  {
    path: "/intake-variety",
    name: "intake-variety",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety"),
    },
  },
  {
    path: "/intake-variety/review/:id",
    name: "intake-variety-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety"),
    },
  },
  {
    path: "/intake-variety/edit/:id",
    name: "intake-variety-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety"),
    },
  },
  {
    path: "/intake-variety/create",
    name: "intake-variety-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety"),
    },
  },
  // intake size
  {
    path: "/intake-size",
    name: "intake-size",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-size"),
    },
  },
  {
    path: "/intake-size/review/:id",
    name: "intake-size-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-size"),
    },
  },
  {
    path: "/intake-size/edit/:id",
    name: "intake-size-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-size"),
    },
  },
  {
    path: "/intake-size/create",
    name: "intake-size-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-size"),
    },
  },
  // intake-variety-size
  {
    path: "/intake-variety-size",
    name: "intake-variety-size",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety-size"),
    },
  },
  {
    path: "/intake-variety-size/review/:id",
    name: "intake-variety-size-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety-size"),
    },
  },
  {
    path: "/intake-variety-size/edit/:id",
    name: "intake-variety-size-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety-size"),
    },
  },
  {
    path: "/intake-variety-size/create",
    name: "intake-variety-size-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("intake-variety-size"),
    },
  },
  // Average Throughput
  {
    path: "/average-throughput",
    name: "average-throughput",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("average-throughput"),
    },
  },
  {
    path: "/average-throughput/review/:id",
    name: "average-throughput-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("average-throughput"),
    },
  },
  {
    path: "/average-throughput/edit/:id",
    name: "average-throughput-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("average-throughput"),
    },
  },
  {
    path: "/average-throughput/create",
    name: "average-throughput-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSettings",
    },
    components: {
      content: lazyLoad("average-throughput"),
    },
  },
];
